export default {
    baseUrl: process.env.BASE_URL,
    uploadUrl: process.env.BASE_URL + '/v1/public/upload/upload',
    downloadUrl: process.env.BASE_URL + '/v1/public/download/download?attachmentPath=',

    // 开发环境当代的服务器地址；
    // baseUrl: 'http://172.18.50.230:83/rest-api',
    // uploadUrl: 'http://172.18.50.230:83/rest-api/v1/public/upload/upload',
    // downloadUrl: 'http://172.18.50.230:83/rest-api/v1/public/download/download?attachmentPath=',

    //UAT环境服务器地址；
    //  baseUrl: 'http://10.51.3.175:83/rest-api',
    //  uploadUrl: 'http://10.51.3.175:83/rest-api/v1/public/upload/upload',
    //  downloadUrl: 'http://10.51.3.175:83/rest-api/v1/public/download/download?attachmentPath=',

	//生产环境服务器地址；
     // baseUrl: 'https://dpmsgw.modernland.hk/rest-api',
     // uploadUrl: 'https://dpmsgw.modernland.hk/rest-api/v1/public/upload/upload',
     // downloadUrl: 'https://dpmsgw.modernland.hk/rest-api/v1/public/download/download?attachmentPath=',

    isPublicRoute(route){
        return !!~['index','slide1','slide2','slide3','slide4','login', 'forget','register','help','win-list','invite-list','not-found'].indexOf(route)
    }
}



// WEBPACK FOOTER //
// ./src/util/index.js